// CSS Modules - component class name prefix: ShopCart__

<template>
  <div :class="$style.container" v-show="!loading">
    <a
      :class="[$style.cartPopper, { ShopCart__disabled: !cartHasItems }]"
      v-tippy="{
        theme: 'wika light tooltip tooltip-bottom',
        interactive: true,
        reactive: true,
        placement: 'bottom',
        flip: false,
        animation: 'perspective',
        animateFill: false,
        arrow: true,
        distance: 11,
        zIndex: 10000,
        html: '#cartPopperContent',
        trigger: 'manual',
        hideOnClick: false
      }"
      ref="tippy"
      @init="initCartTippy"
      @click="cartHasItems && isMobileDevice && showCartPopper()"
      @mouseenter="cartHasItems && !isMobileDevice && showCartPopper()"
    >
      <i class="fas fa-shopping-cart"></i>
      <div :class="$style.badge">{{ cartData.quantity }}</div>
      <span v-html="formatMoney(cartData.pricesum)"></span>
    </a>
    <div
      id="cartPopperContent"
      :class="$style.popperContent"
      @mouseleave="hideCartPopper"
    >
      <div v-if="cartData" class="columns is-mobile is-multiline">
        <div
          v-for="(item, index) in cartData.items"
          :key="index"
          :class="[$style.cartItem, 'column is-full']"
          @mouseenter="addActiveClass"
          @mouseleave="removeActiveClass"
        >
          <div
            :ref="`infoPopperContent-${index}`"
            :class="$style.infoPopperContent"
          >
            <i class="fas fa-info-circle"></i>
            {{ item.longtext }}
          </div>
          <div class="columns is-mobile">
            <div class="column is-one-third">
              <img :src="item.thumbnail" :alt="item.title" />
            </div>
            <div :class="[$style.priceBox, 'column is-two-thirds']">
              <a @click="removeItem(item)" :class="$style.trash">
                <i class="fas fa-trash-alt"></i>
              </a>
              <strong :class="$style.title">{{ item.title }}</strong>
              <div>{{ item.name }}</div>
              <p :class="$style.heading">
                {{ config.itemNumber }}: {{ typeof item !== 'undefined' && typeof item.id !== 'undefined' && !item.id.includes("none_") ? item.id : config.noArtNoAvailableText }}
                <a>
                  <i
                    @mouseenter="showInfoPopper(index)"
                    @mouseleave="hideInfoPopper(index)"
                    :class="[$style.infoPopper, 'fas fa-info-circle']"
                  ></i>
                </a>
              </p>
              <div>
                {{ config.pricePerItem }}:
                <span v-html="formatMoney(item.pricesingle)"></span>
              </div>
              <div :class="$style.countSum">
                <div :class="$style.label">{{ config.quantity }}:</div>
                <FormSelect
                  v-model="item.quantity"
                  :options="selectOptions"
                  :initialOption="item.quantity"
                  @input="updateQuantity(item)"
                />
                <div :class="$style.label">
                  <span v-html="formatMoney(item.pricesum)"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          :class="[
            $style.cartTotal,
            'column is-offset-one-third is-two-thirds'
          ]"
        >
          <div :class="$style.sum">
            {{ config.totalPrice }}:
            <span v-html="formatMoney(cartData.pricesum)"></span>
          </div>
          <div :class="$style.tax">
            {{ config.tax }} &amp;
            <a :href="config.shippingUrl">
              {{ config.shippingText }}
            </a>
          </div>
          <Button
            colour="blue"
            :text="config.buttonText"
            :isLink="true"
            :href="config.shopCartUrl"
          >
          </Button>
        </div>
      </div>
    </div>
    <ShopCartPopper
      :config="config"
      :item="newItem"
      :isPopperOpen="newItemIsSet"
    />
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import Button from "../Button/Button";
import FormSelect from "../FormSelect/FormSelect";
import ShopCartPopper from "../ShopCart/ShopCartPopper";
import CustomEvents from "../../globals/constants/customEvents";
import removeItemToUrl from "../../xhr/shopCart/removeItemToUrl";
import updateQuantityToUrl from "../../xhr/shopCart/updateQuantityToUrl";
import getCartFromUrl from "../../xhr/shopCart/getCartFromUrl";

export default {
  name: "ShopCart",
  components: {
    Button,
    FormSelect,
    ShopCartPopper
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: true,
      isMobileDevice: isMobile,
      cartData: {
        quantity: 0,
        pricesum: 0,
        items: []
      },
      newItem: {},
      newItemIsSet: false
    };
  },
  computed: {
    selectOptions: function() {
      const range = (start, end) =>
        [...Array(end - start + 1)].map((_, i) => start + i).map(String);
      return range(1, this.config.selectOptionMax);
    },
    cartHasItems: function() {
      return this.cartData.quantity !== 0;
    }
  },
  methods: {
    initCartTippy(tippy) {
      tippy.popper.id = "cartPopper";
    },
    initAddToCartTippy(tippy) {
      tippy.popper.id = "addToCartPopper";
    },
    showCartPopper() {
      this.$refs.tippy._tippy.show();
    },
    hideCartPopper() {
      this.$refs.tippy._tippy.hide();
    },
    showInfoPopper(index) {
      for (let ref in this.$refs) {
        if (`infoPopperContent-${index}` === ref) {
          this.$refs[ref][0].classList.add("ShopCart__infoVisible");
        }
      }
    },
    hideInfoPopper(index) {
      for (let ref in this.$refs) {
        if (`infoPopperContent-${index}` === ref) {
          this.$refs[ref][0].classList.remove("ShopCart__infoVisible");
        }
      }
    },
    openAddToCartPopper(data) {
      this.newItem = data.items[0];
      this.newItemIsSet = true;
      this.getCart();
      setTimeout(() => {
        this.newItemIsSet = false;
      }, 3000);
    },
    addActiveClass(event) {
      event.currentTarget.classList.add("active");
    },
    removeActiveClass(event) {
      event.currentTarget.classList.remove("active");
    },
    formatMoney(value) {
      const price = value.toString().replace(".", ",");
      return accounting.formatMoney(
        parseFloat(price.replace(".", "").replace(",", ".")),
        {
          symbol: this.config.currency,
          format: this.config.currencyPosition,
          decimal: this.config.decimalSep,
          thousand: this.config.thousandSep,
          precision: this.config.precisionValue
        }
      );
    },
    getCart() {
      getCartFromUrl(window.getCartUrl, {
        country: window.currentCountry,
        language: window.currentLanguage
      })
        .then(cartData => (this.cartData = cartData))
        .catch(error => console.error(error))
        .finally(() => (this.loading = false));
    },
    addItem(event) {
      this.openAddToCartPopper(event.detail);
    },
    updateQuantity(item) {
      updateQuantityToUrl(window.updateItemQuantityUrl, {
        itemid: item.id,
        quantity: item.quantity,
        country: window.currentCountry,
        language: window.currentLanguage
      })
        .then(() => {
          this.getCart();
        })
        .catch(error => console.error(error));
    },
    removeItem(item) {
      removeItemToUrl(window.removeItemUrl, {
        itemid: item.id,
        country: window.currentCountry,
        language: window.currentLanguage
      })
        .then(() => {
          this.getCart();
        })
        .catch(error => console.error(error));
    }
  },
  created() {
    this.getCart();
  },
  mounted() {
    window.addEventListener(CustomEvents.ADD_TO_CART, this.addItem, false);
    window.addEventListener(CustomEvents.UPDATE_SHOP_CART, this.getCart, false);
  },
  destroyed() {
    window.removeEventListener(CustomEvents.ADD_TO_CART, this.addItem, false);
    window.removeEventListener(
      CustomEvents.UPDATE_SHOP_CART,
      this.getCart,
      false
    );
  }
};
</script>

<style module lang="scss">
@import "./ShopCart.scss";
</style>
